import React, { useState } from "react";
import { Copy } from "lucide-react";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const API = process.env.REACT_APP_BACKEND_URL;

// Public read-only link + QR code to project in class (cards, mind maps…).
export function PublicShareDialog({ open, onOpenChange, title, url, isPublic, onToggle, hint, testid }) {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);
  const copy = async () => {
    try { await navigator.clipboard.writeText(url); toast.success(t("share.copied", "Lien copié.")); } catch { toast.error(t("share.copy_failed", "Copie impossible : sélectionnez le lien et copiez-le.")); }
  };
  const toggle = async () => {
    setBusy(true);
    try { await onToggle(!isPublic); } catch { toast.error(t("share.failed", "Échec du partage.")); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid={`${testid}-dialog`}>
        <DialogHeader><DialogTitle>{title}</DialogTitle></DialogHeader>
        <label className="flex items-center gap-2 text-sm">
          <input type="checkbox" checked={!!isPublic} onChange={toggle} disabled={busy} data-testid={`${testid}-toggle`} />
          {t("share.public_label", "Lien public (lecture seule, sans compte)")}
        </label>
        {isPublic && (
          <>
            <div className="flex gap-2">
              <input readOnly value={url} className="flex-1 border border-border px-2 py-2 text-xs" data-testid={`${testid}-url`} />
              <button type="button" onClick={copy}
                className="px-3 border border-[#002FA7] text-[#002FA7]" aria-label={t("share.copy", "Copier")} data-testid={`${testid}-copy`}><Copy className="w-4 h-4" /></button>
            </div>
            <img src={`${API}/api/qr?data=${encodeURIComponent(url)}`} alt="QR code" className="w-56 h-56 mx-auto" data-testid={`${testid}-qr`} />
            <p className="text-xs text-muted-foreground text-center">{hint}</p>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}

export default PublicShareDialog;
